import NavBar from "../components/navbar";

new NavBar();
